import React from 'react';
import { connect } from 'react-redux';
import Leaflet from 'leaflet';
import '../../stylesheets/leaflet-custom.css';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';

class LeafletMap extends React.Component {
  constructor() {
    super();
    this.state = {
      lat: 12.9716,
      lng: 77.5946,
      zoom: 14,
      governanceLayer: {},
      nearbyFeaturesAreLoading: false,
      nearbyFeaturesAreLoaded: false
    };
    this.disableMap = this.disableMap.bind(this, false);
    this.enableMap = this.enableMap.bind(this, false);
    this.onMoveMap = this.onMoveMap.bind(this, false);
  }
  disableMap() {
    let map = this.refs.map.leafletElement;
    map.dragging.disable();
    map.touchZoom.disable();
    map.doubleClickZoom.disable();
    map.scrollWheelZoom.disable();
    map.boxZoom.disable();
    map.keyboard.disable();
    if (map.tap) map.tap.disable();
  }
  enableMap() {
    let map = this.refs.map.leafletElement;
    map.dragging.enable();
    map.touchZoom.enable();
    map.doubleClickZoom.enable();
    map.scrollWheelZoom.enable();
    map.boxZoom.enable();
    map.keyboard.enable();
    if (map.tap) map.tap.enable();
  }
  componentWillReceiveProps(nextProps) {
    let governanceLayer = this.state.governanceLayer;
    if ((nextProps.currentFeature)
      && (nextProps.currentFeature.properties)
      && (nextProps.currentFeature.properties.ward_id)) {
      if (this.refs.map.leafletElement.hasLayer(governanceLayer))
        this.refs.map.leafletElement.removeLayer(this.state.governanceLayer);
      governanceLayer = Leaflet.geoJSON().addTo(this.refs.map.leafletElement);
      governanceLayer.addData(nextProps.currentFeature, {
        style: {
          'fill': nextProps.currentFeature.properties.fill,
          'fill-opacity': nextProps.currentFeature.properties['fill-opacity'],
          'stroke': nextProps.currentFeature.properties.fill,
          'stroke-opacity': nextProps.currentFeature.properties['stroke-opacity'],
          'stroke-width': nextProps.currentFeature.properties['stroke-width']
        }
      });
    }
    if (nextProps.nearbyFeaturesAreLoading && (!nextProps.nearbyFeaturesAreLoaded)) {
      this.disableMap();
    }
    else {
      this.enableMap();
    }
    this.setState({
      governanceLayer: governanceLayer,
      nearbyFeaturesAreLoading: nextProps.nearbyFeaturesAreLoading,
      nearbyFeaturesAreLoaded: nextProps.nearbyFeaturesAreLoaded
    });
  }
  componentDidMount() {
    this.refs.map.leafletElement.locate({ setView: true });
    this.refs.map.leafletElement.on('locationfound', () => {
      this.onMoveMap();
    });
    this.refs.map.leafletElement.on('locationerror', () => {
      this.onMoveMap();
    });
  }
  componentShouldMount() {
    return ((!this.props.nearbyFeaturesAreLoading)
      && (this.props.nearbyFeaturesAreLoaded)
    );
  }
  onMoveMap() {
    let bounds = this.refs.map.leafletElement.getBounds();
    let center = this.refs.map.leafletElement.getCenter();
    let radius = this.refs.map.leafletElement.distance(bounds._northEast, bounds._southWest) / 2;
    let zoom = this.refs.map.leafletElement.getZoom();
    this.props.map.setView(center, zoom, radius, bounds);
  }
  render() {
    const position = [this.state.lat, this.state.lng];
    return <div>
      <Map center={position} zoom={this.state.zoom}
        zoomDelta={0.1} zoomSnap={0.1}
        maxBoundsViscosity={0.5}
        className="leaflet-container" ref="map" onMoveEnd={this.onMoveMap} id="leaflet-map">
        <TileLayer
          attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
      </Map>
    </div>;
  }
}

export default connect((state) => {
  return ({
    map: state.map,
    currentFeature: state.governanceData.currentFeature,
    nearbyFeaturesAreLoading: state.governanceData.isLoading,
    nearbyFeaturesAreLoaded: state.governanceData.loadComplete
  });
})(LeafletMap);



// WEBPACK FOOTER //
// ./src/components/maps/LeafletMap.js